// extracted by mini-css-extract-plugin
export var award = "Awards-module--award--4bd94";
export var awardGrid = "Awards-module--award-grid--f3d64";
export var awardImage = "Awards-module--award-image--14822";
export var awardTitleOnRight = "Awards-module--award-title-on-right--a7802";
export var awardsContainer = "Awards-module--awards-container--da220";